import { inTestEnvironment } from 'shared/javascripts/util/environment'

up.compiler('[data-scroll-reveal]', (element) => {
  if (inTestEnvironment()) {
    element.classList.add('-revealed')
    return
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        element.classList.add('-revealed')
        observer.disconnect()
      }
    },
    { threshold: 0.2 },
  )

  observer.observe(element)

  return () => observer.disconnect()
})
